import { MenuAction } from '@shared/interfaces/header/menu-action';
import { ChartBar, ChartLine, ChartPie } from 'lucide-angular';

export const timeSeriesGraphVisualizationsMenuAction: MenuAction[] = [
  {
    id: 'line',
    title: 'common.graph.line',
    icon: ChartLine,
  },
  {
    id: 'bar',
    title: 'common.graph.bar',
    icon: ChartBar,
  },
  {
    id: 'pie',
    title: 'common.graph.pie',
    icon: ChartPie,
  },
  {
    id: 'doughnut',
    title: 'common.graph.doughnut',
    icon: ChartPie,
  },
]
